import { render, staticRenderFns } from "./Prize10DrawComponent.vue?vue&type=template&id=451f3d54&scoped=true"
import script from "./Prize10DrawComponent.vue?vue&type=script&lang=js"
export * from "./Prize10DrawComponent.vue?vue&type=script&lang=js"
import style0 from "./Prize10DrawComponent.vue?vue&type=style&index=0&id=451f3d54&prod&lang=css"
import style1 from "./Prize10DrawComponent.vue?vue&type=style&index=1&id=451f3d54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451f3d54",
  null
  
)

export default component.exports